<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span>扫码查询</span>
      </div>
    </div>
    <div class="content_bg" style="margin-bottom: 1.833rem">
      <div class="o_blue_box">
        <!--批次-->
        <p class="batch_num">{{ orderData.order_no }}_{{ orderData.no }}</p>
        <!--扫码详情信息-->
        <div class="scan_detail_bg">
          <div class="scan_detail_box">
              <table>
                <tr>
                  <td>制造单号</td>
                  <td>{{ orderData.order_no }}</td>
                </tr>
                <tr>
                  <td>型体</td>
                  <td>{{ orderData.mod }}</td>
                </tr>
                <tr>
                  <td>订单总数量</td>
                  <td>{{ orderData.num }}</td>
                </tr>
                <tr>
                  <td>SIZE</td>
                  <td>{{ orderData.size }}</td>
                </tr>
                <tr>
                  <td>SIZE总数量</td>
                  <td>{{ orderData.size_num }}</td>
                </tr>
                <tr>
                  <td>编号</td>
                  <td>{{ orderData.no }}</td>
                </tr>
              </table>
          </div>
        </div>

        <!--产品图片-->
        <div class="scan_img_box">
          <img :src="orderData.img" alt="">
        </div>
      </div>
    </div>

    <!--重新下发按钮-->
    <div class="re_send_box" v-show="type == 'rs'">
      <input class="re_send_btn" type="button" value="重新下发" @click="returnSend()">
    </div>
    <!--重新下发遮罩层-->
    <div class="weui-mask" id="iosMask" ref="iosMask" style="display: none"></div>
    <div class="weui-actionsheet" id="iosActionsheet" ref="iosActionsheet">
      <div class="weui-actionsheet__title">
        <!--<span><i class="weui-icon-success weui-icon_msg" style="font-size: 0.433rem;padding-right: 0.1rem"></i>扫码成功，请选择下发部门！</span>-->
        <span>请选择下发部门！</span>
      </div>
      <div class="weui-actionsheet__menu">
        <input type="hidden" name="order_id" ref="r_s_id">
        <input type="hidden" name="no" ref="r_s_no">
        <div class="weui-actionsheet__cell" @click="confirmSend(1)">针车部</div>
        <div class="weui-actionsheet__cell" @click="confirmSend(3)">成型部</div>
        <div class="weui-actionsheet__cell" @click="confirmSend(5)">装配部</div>
      </div>
      <div class="weui-actionsheet__action">
        <div class="weui-actionsheet__cell" id="iosActionsheetCancel" @click="cancelReturnSend()">取消</div>
      </div>
    </div>
    <loading v-show="loading"></loading>
    <success v-show="success"></success>
  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import success from  '@/components/success'
  import loading from '@/components/loading'
  export default {
    name:'scanDetail',
    components:{
      loading,
      success,
    },
    data(){
      return{
        orderData:'',
        type:'',
        order_id:'',
        no:'',
//        初始化
        loading:false,
        success:false,
      }
    },
    created:function () {
      var that = this;
      var token = localStorage.getItem('token');
      var order_id = that.$route.query.order_id;
      var size_id = that.$route.query.size_id;
      var no = that.$route.query.no;
      that.type = that.$route.query.type;
      that.order_id = that.$route.query.order_id;
      that.no = that.$route.query.no;
      var formData = new FormData();
      formData.append('token',token);
      formData.append('order_id',order_id);
      formData.append('size_id',size_id);
      formData.append('no',no);
      that.loading = true;
      that.app.postData('/mhome.php/Order/getInfo',formData
        ,result =>{
          that.orderData = result.content.order_data;
        },() =>{
          that.loading = false;
        })
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
      //      打开重新下发
      returnSend(){
        this.$refs.iosActionsheet.classList.add('weui-actionsheet_toggle');
        $('#iosMask').fadeIn(200);
      },
//      取消重新下发
      cancelReturnSend(){
        this.$refs.iosActionsheet.classList.remove('weui-actionsheet_toggle');
        $('#iosMask').fadeOut(200);
      },
//      点击确认重新下发
      confirmSend(status){
        var that = this;
        var token = localStorage.getItem('token');
        var order_id = that.order_id;
        var no = that.no;
        var formData = new FormData();
        formData.append('token',token);
        formData.append('order_id',order_id);
        formData.append('status',status);
        formData.append('no',no);
        if( order_id == '' || no == '' ){
          webToast('数据出错，请重新扫码','middle',1500);
          var closeRs = setTimeout(function () {
            that.cancelReturnSend()
          },1500);
          return false;
        }else{
          that.loading = true;
          that.app.postData('/mhome.php/Order/reset',formData
            ,result =>{
              if( result.status == 200 ){
//                webToast(result.message,'middle',1500);
                that.success = true;
                var closeRs = setTimeout(function () {
                  that.success = false;
                  that.cancelReturnSend()
                },1500);
              }
              if( result.status == 503 ){
                webToast(result.message,'middle',1500);
              }
            },()=>{
              that.loading = false;
            })
        }
      },
    },
    beforeRouteEnter(to,from,next){
      window.document.body.style.background  = '#f4f4f4';
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>

<style scoped>
  table tr td{
    text-align: left;
    color: #4598FF;
    border-right:1px solid #A2CBFF;
    border-bottom:1px solid #A2CBFF;
  }
  table tr{
    display: flex;
  }
  table tr td:first-child{
    flex: 1 !important;
  }
  table tr td{
    flex: 2;
  }
  table tr td:first-child{
    color: #333333 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/scanDetail.vue